import { Component } from 'react'
import forgotPasswordImg from '../../../../assets/images/forgot_password.png'
import { Input } from '../../../components/input'
import { Select } from '../../../components/select'
import { ErrorMessage, errorsLength, formatErrors, emptyField, CPFValidator, CNPJValidator } from '../../../../insfrastructure/utils/form-validators'
import { analytics } from '../../../../insfrastructure/services/analytics'
import './styles.sass'

export default class ForgotEmail extends Component<any> {
    state: any = {
        form: {
            profile_type: '',
            cpf: '',
            cnpj: ''
        },
        formErrors: {}
    }

    profileTypeOptions = [
        { value: 'candidate', label: 'Candidato' },
        { value: 'company', label: 'Empresa' }
    ]

    allowedProfileTypes = ['candidate', 'company']

    validateProfileType = (value: string): string => {
        if (!value || value.trim() === '') {
            return 'Selecione o perfil';
        }
        if (!this.allowedProfileTypes.includes(value)) {
            return 'Tipo de perfil inválido';
        }
        return '';
    }

    onSubmit = () => {
        this.setState({ formErrors: {} });
        
        const fields: Record<string, any> = {
            profile_type: [
                emptyField(this.state.form.profile_type, 'string'),
                this.validateProfileType(this.state.form.profile_type)
            ]
        };

        // Validar campo específico baseado no tipo de perfil
        if (this.state.form.profile_type === 'candidate') {
            fields['cpf'] = [
                emptyField(this.state.form.cpf, 'string'),
                CPFValidator(this.state.form.cpf)
            ];
        } else if (this.state.form.profile_type === 'company') {
            fields['cnpj'] = [
                emptyField(this.state.form.cnpj, 'string'),
                CNPJValidator(this.state.form.cnpj)
            ];
        }

        const errors = formatErrors(fields);

        if(errorsLength(errors) > 0) {
            this.setState({ formErrors: errors });
            return;
        }

        // Verificar se o profile_type é válido antes de continuar
        if (!this.allowedProfileTypes.includes(this.state.form.profile_type)) {
            this.setState({ 
                formErrors: { 
                    ...this.state.formErrors, 
                    profile_type: ['Tipo de perfil inválido. Por favor, selecione Candidato ou Empresa.'] 
                } 
            });
            return;
        }

        // Rastrear tentativa de recuperação de email
        analytics.trackFormSubmission('forgot_email');

        // Preparar mensagem para WhatsApp baseada no tipo de perfil
        let message = '';
        
        if (this.state.form.profile_type === 'candidate') {
            message = `Olá, estou sem acesso ao email cadastrado com o meu CPF ${this.state.form.cpf} e preciso de ajuda`;
        } else if (this.state.form.profile_type === 'company') {
            message = `Olá, estou sem acesso ao email cadastrado com o CNPJ da minha empresa ${this.state.form.cnpj} e preciso de ajuda`;
        }
        
        // Validação de segurança: garantir que a mensagem não está vazia
        if (!message || message.trim() === '') {
            analytics.trackError(new Error('Empty WhatsApp message'), 'forgot_email_empty_message');
            this.setState({ 
                formErrors: { 
                    ...this.state.formErrors, 
                    profile_type: ['Erro ao preparar mensagem. Por favor, tente novamente.'] 
                } 
            });
            return;
        }
        
        // Codificar mensagem para URL
        const encodedMessage = encodeURIComponent(message);
        const whatsappNumber = '5519981520335';
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
        
        // Redirecionar para WhatsApp
        window.open(whatsappUrl, '_blank');
        
        analytics.addBreadcrumb('Redirected to WhatsApp support for email recovery', 'auth', 'info');
    }

    render() {
        return (
            <div className='forgot-email unlogged-page'>
                <div className='content'>
                    <div className='block'>
                        {window.innerWidth > 1000 &&
                        <div className='img-container'>
                            <img src={forgotPasswordImg} alt='forgot-email-image' />
                        </div>}
                        <div className='block-content not-sended'>
                            <div className='text'>
                                <h1>Esqueceu seu Email?</h1>
                            </div>
                            <div className='form'>
                                <Select
                                name='profile_type'
                                label='Selecione o perfil'
                                placeholder='Selecione o perfil'
                                options={this.profileTypeOptions}
                                value={this.state.form.profile_type}
                                allowEmpty={false}
                                onChange={e => this.setState({ form: {...this.state.form, profile_type: e, cpf: '', cnpj: ''} })}/>
                                <ErrorMessage errors={this.state.formErrors['profile_type']} />
                                {this.state.form.profile_type === 'candidate' && (
                                    <>
                                        <Input
                                        name='cpf'
                                        label='CPF'
                                        placeholder='Insira seu CPF'
                                        mask='999.999.999-99'
                                        onChange={e => this.setState({ form: {...this.state.form, cpf: e} })}/>
                                        <ErrorMessage errors={this.state.formErrors['cpf']} />
                                    </>
                                )}
                                {this.state.form.profile_type === 'company' && (
                                    <>
                                        <Input
                                        name='cnpj'
                                        label='CNPJ'
                                        placeholder='Insira seu CNPJ'
                                        mask='99.999.999/9999-99'
                                        onChange={e => this.setState({ form: {...this.state.form, cnpj: e} })}/>
                                        <ErrorMessage errors={this.state.formErrors['cnpj']} />
                                    </>
                                )}
                            </div>
                            <p className='bottom-text'>Ao clicar em <b>"falar com o suporte"</b>, você será direcionado ao nosso suporte no Whatsapp.</p>
                            <button className='submit-btn secondary support-btn' onClick={this.onSubmit}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#105099" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                    <line x1="9" y1="10" x2="15" y2="10"></line>
                                    <line x1="12" y1="7" x2="12" y2="13"></line>
                                </svg>
                                Falar com o suporte
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
